var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _circle2, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorldwideContactCenterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "worldwide_1_",
    "data-name": "worldwide (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.472,
    height: 51.473,
    viewBox: "0 0 51.472 51.473",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3382",
    "data-name": "Path 3382",
    d: "M182.263,181.553q0-2.515-.172-4.853a5.084,5.084,0,0,1-3.882-3.468H164.227a64.814,64.814,0,0,0-.521,8.321c0,1.819.071,3.57.2,5.246a5.085,5.085,0,0,1,3.852,3.462h13.931A64.487,64.487,0,0,0,182.263,181.553Z",
    transform: "translate(-147.248 -155.817)",
    fill: "#7dbaab"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3383",
    "data-name": "Path 3383",
    d: "M322.646,17.78a5.08,5.08,0,0,1,4.3,3.531h8.2A25.844,25.844,0,0,0,318.313,7.684a22.408,22.408,0,0,1,2.765,5.144,39.513,39.513,0,0,1,1.568,4.952Z",
    transform: "translate(-286.312 -6.912)",
    fill: "#7dbaab"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3384",
    "data-name": "Path 3384",
    d: "M13.662,187.119c-.145-1.814-.22-3.677-.22-5.567a68.193,68.193,0,0,1,.5-8.321H1.381a25.749,25.749,0,0,0,.137,17.029h9.317A5.092,5.092,0,0,1,13.662,187.119Z",
    transform: "translate(0 -155.817)",
    fill: "#7dbaab"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3385",
    "data-name": "Path 3385",
    d: "M40.554,376.165a5.079,5.079,0,0,1-4.4-3.54H28.143a25.843,25.843,0,0,0,16.642,13.239,22.408,22.408,0,0,1-2.765-5.144A38.976,38.976,0,0,1,40.554,376.165Z",
    transform: "translate(-25.314 -335.164)",
    fill: "#7dbaab"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3386",
    "data-name": "Path 3386",
    d: "M173.618,14.4h13.506a5.093,5.093,0,0,1,2.414-2.941C187.733,4.344,184.714,0,181.9,0,178.717,0,175.272,5.56,173.618,14.4Z",
    transform: "translate(-156.164)",
    fill: "#7dbaab"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3387",
    "data-name": "Path 3387",
    d: "M35.1,12.215a5.067,5.067,0,0,1-6.3,4.916,25.78,25.78,0,0,0-2.582,4.18H37.973a43.973,43.973,0,0,1,2.316-8.483,22.408,22.408,0,0,1,2.765-5.144,25.618,25.618,0,0,0-8.048,3.585A5.074,5.074,0,0,1,35.1,12.215Z",
    transform: "translate(-23.582 -6.912)",
    fill: "#7dbaab"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3388",
    "data-name": "Path 3388",
    d: "M326.271,381.334a5.067,5.067,0,0,1,6.3-4.916,25.8,25.8,0,0,0,2.389-3.792H323.323a43.5,43.5,0,0,1-2.245,8.1,22.409,22.409,0,0,1-2.765,5.144,25.618,25.618,0,0,0,8.048-3.585A5.064,5.064,0,0,1,326.271,381.334Z",
    transform: "translate(-286.312 -335.164)",
    fill: "#7dbaab"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3389",
    "data-name": "Path 3389",
    d: "M196.655,372.625H183.222a5.091,5.091,0,0,1-2.326,2.89c1.814,6.914,4.782,11.121,7.55,11.121C191.582,386.637,194.974,381.239,196.655,372.625Z",
    transform: "translate(-162.71 -335.164)",
    fill: "#7dbaab"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3390",
    "data-name": "Path 3390",
    d: "M385.311,190.261a25.749,25.749,0,0,0,.137-17.029h-9.454a5.092,5.092,0,0,1-2.8,3.129c.126,1.7.191,3.432.191,5.192a67.913,67.913,0,0,1-.548,8.709Z",
    transform: "translate(-335.357 -155.817)",
    fill: "#7dbaab"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3391",
    "data-name": "Path 3391",
    d: "M337.738,141.928a2.052,2.052,0,1,0-2.051-2.052A2.054,2.054,0,0,0,337.738,141.928Z",
    transform: "translate(-301.94 -123.969)",
    fill: "#7dbaab"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    cx: 2.052,
    cy: 2.052,
    r: 2.052,
    transform: "translate(13.622 33.901)",
    fill: "#7dbaab"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 2.052,
    cy: 2.052,
    r: 2.052,
    transform: "translate(4.395 3.252)",
    fill: "#7dbaab"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3392",
    "data-name": "Path 3392",
    d: "M429.526,438.843a2.052,2.052,0,1,0,2.051,2.052A2.054,2.054,0,0,0,429.526,438.843Z",
    transform: "translate(-384.499 -394.725)",
    fill: "#7dbaab"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldwideContactCenterIcon);
export default __webpack_public_path__ + "static/media/worldwide-contact-center-icon.2c95271116e4a87b74cc29f1374da97f.svg";
export { ForwardRef as ReactComponent };